module.exports = __webpack_public_path__ + "media/newstyle/images/second-circle-73a944663a70af32dbe63e7e874d643f.svg";